checkIfCartLoadedMultipleTime = () => {
  if (document.querySelectorAll("#cart-drawer").length > 1) {
    document.querySelectorAll("#cart-drawer").forEach((cart, index) => {
      if (index != 0) {
        cart.remove();
        setTimeout(checkIfCartLoadedMultipleTime, 100);
      }
    });
  } else {
    setTimeout(checkIfCartLoadedMultipleTime, 100);
  }
};
checkIfCartLoadedMultipleTime();

async function cleanCart() {
    try {
        // Fetch the cart data
        let response = await fetch('/cart.js');
        let cart = await response.json();

        let cartItems = cart.items;
        let variantIds = cartItems.map(item => item.variant_id.toString()); // Store all variant IDs in cart

        let itemsToRemove = [];

        // Loop through cart items
        cartItems.forEach(item => {
            if (item.properties && item.properties.topLevelVariant) {
                let topLevelVariant = item.properties.topLevelVariant.toString();
                
                // Check if the referenced topLevelVariant exists in the cart
                if (!variantIds.includes(topLevelVariant)) {
                    itemsToRemove.push(item.key);
                }
            }
        });

        // If items need to be removed, update the cart
        if (itemsToRemove.length > 0) {
            let updates = {};
            itemsToRemove.forEach(key => {
                updates[key] = 0; // Set quantity to 0 to remove item
            });

            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
            });

          let event = new Event("cart:refresh");
          document.dispatchEvent(event);
            // Reload the cart to reflect changes
            location.reload();
        }
    } catch (error) {
        console.error("Error updating cart:", error);
    }
}

// Run the function
cleanCart();


document.addEventListener('cart:refresh', () => {
    
    cleanCart();
});
document.addEventListener('cart:change', () => {
    
    cleanCart();
});